import Vue from 'vue'
import * as sentry from '@sentry/vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueLazyLoad from 'vue-lazyload'
// eslint-disable-next-line no-unused-vars
import 'popper.js/dist/popper.min'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AccountLayout from '@/layouts/AccountLayout.vue'
import api from './utils/api'

import App from './App.vue'
import router from './router'
import store from './store'

import './assets/sass/custom.scss'

sentry.init({
  Vue,
  dsn: 'https://6ab5521c5f21ad991a3f0c84761af5ba@o4506305045921792.ingest.sentry.io/4506305093107712',
})

// Configure font-awesome
library.add(far)
library.add(fab)
library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Base
Vue.component('default-layout', DefaultLayout)
Vue.component('account-layout', AccountLayout)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueLazyLoad, {
  attempt: 1,
})

Vue.config.productionTip = false

Vue.prototype.$http = api

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// Fetch the canonical regions list after mount; the store already has a
// synchronous default so the first paint isn't blocked on this.
store.dispatch('Region/loadAvailable')
